<template>
	<b-modal
		:hide-footer="true"
		:hide-header-close="true"
		:no-close-on-backdrop="true"
		:no-close-on-esc="true"
		:title="$t('Add role')"
		centered
		id="add-role"
		no-fade
		size="xl"
	>
		<template v-slot:default>
			<loading-animation
				:active.sync="loading"
				:is-full-page="false"
				:opacity="1"
				color="#5685D8"
			/>
			<form @submit.prevent="addRole" ref="addRole">
				<b-form-group class="mb-2" label-for="name">
					<template v-slot:label
						>{{ $t("Nome") }} <span class="text-danger">*</span></template
					>
					<b-form-input id="name" required v-model="role.name" />
				</b-form-group>
				<label>{{ $t("Permissions") }} <span class="text-danger">*</span></label>

				<div class="row m-0">
					<div
						class="col-md-4 p-3"
						v-for="(permission, index) in permissionsList"
						style="border: 1px solid #eee"
						:key="index"
					>
						{{ permissionsLabels[index] }}
						<div class="float-right">
							<toggle-button
								:sync="true"
								color="#5685D8"
								id="status"
								name="status"
								v-model="role.permissions[index]"
							/>
						</div>
					</div>
				</div>

				<div class="float-right mt-3">
					<router-link class="btn btn-danger" to="/dashboard/admin/roles">
						<i class="mdi mdi-close" />
						{{ $t("Cancel") }}
					</router-link>
					<button class="btn btn-success btn-submit" data-style="zoom-in" type="submit">
						<i class="mdi mdi-content-save" />
						{{ $t("Create") }}
					</button>
				</div>
			</form>
		</template>
	</b-modal>
</template>

<script>
export default {
	name: "Add",
	mounted() {
		this.$bvModal.show("add-role");
		this.getPermissions();
	},
	data() {
		return {
			loading: true,
			permissionsList: [],
			permissions: [],
			role: {
				name: null,
				permissions: [],
			},
			permissionsLabels: [],
		};
	},
	methods: {
		// Get permissions list
		getPermissions() {
			// Get all settings values
			axios.get("api/dashboard/roles/permissions").then((response) => {
				this.role.permissions = response.data.data.controllers;
				this.permissionsList = response.data.data.controllers;
				this.permissionsLabels = response.data.data.controllerLabels;
				this.loading = false;
			});
		},
		// Add role
		addRole() {
			let ladda = Ladda.create(document.querySelector(".btn-submit"));
			ladda.start();
			// Send request
			axios.post("api/dashboard/roles", this.role).then((response) => {
				ladda.stop();
				this.$snack.success({
					button: false,
					text: response.data.data.message,
				});
				this.$router.push("/dashboard/admin/roles");
				this.$parent.getRoles();
			});
		},
	},
};
</script>
